import React from 'react'
import { AboutConfig } from '../../constants'

const About = (props) => {
    let country = props.countryCode
    return (
        <section className='selection:bg-white selection:text-primary' id='about'>
            <div className="svg text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path fill="currentColor" fill-opacity="1" d="M0,224L48,213.3C96,203,192,181,288,186.7C384,192,480,224,576,218.7C672,213,768,171,864,170.7C960,171,1056,213,1152,208C1248,203,1344,149,1392,122.7L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
                </svg>
            </div>
            <div className='overflow-x-hidden bg-primary'>
                <div className="bg-primary flex justify-center text-light px-4">
                    <div>
                        <div className='text-center'>
                            <h1 className='text-3xl font-semibold selection:bg-white selection:text-primary'>About Me</h1>
                            <div className='flex justify-center items-center'>
                                <div className="w-10 h-[0.1px] bg-light"></div>
                                <h1 className='mx-1.5 selection:bg-white selection:text-primary'>rudin</h1>
                                <div className="w-10 h-[0.1px] bg-light"></div>
                            </div>
                            <div className="about-paragraph flex justify-center">
                                <p className='selection:bg-white selection:text-primary sm:max-w-[85%]' dangerouslySetInnerHTML={{ __html: AboutConfig[country].paragraph }}></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="service" className='bg-primary p-8 selection:bg-white selection:text-primary'>
                <div>
                    <div className="service-header flex justify-center items-center">
                        <h1 className='text-3xl font-bold text-light selection:bg-white selection:text-primary'>Service</h1>
                    </div>
                    <div className='flex flex-wrap justify-center md:justify-between sm:px-8'>
                        {
                            AboutConfig[country].service.map((value, index) => (
                                <div className="p-2 w-full md:w-1/3 sm:w-1/2">
                                    <div className="bg-primary p-4">
                                        <div className='text-white'>
                                            <div className="svg flex justify-center items-center">
                                                <img src={ require(`../../assets/icons/${value.icon}`) } alt={`${value.name} Icon`} className='w-10 h-10'/>
                                            </div>
                                            <div className='flex justify-center items-center mt-1'>
                                                <h1 className='font-semibold text-xl selection:bg-white selection:text-primary'>{ value.name }</h1>
                                            </div>
                                            <div className='text-center'>
                                                <p className='selection:bg-white selection:text-primary'>{ value.text }</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            <div className="svg text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="currentColor" fill-opacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,128C672,128,768,160,864,160C960,160,1056,128,1152,106.7C1248,85,1344,75,1392,69.3L1440,64L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"></path></svg>
            </div>
        </section>
    )
}

export default About